import { GradientColorTokens, IconAlignmentTokens, IconSizeTokens, IconTokens, TagTypeTokens, } from '@voltmoney/schema';
export const args = {
    label: 'Tag',
    type: TagTypeTokens.DEFAULT,
    icon: {
        name: IconTokens.Fire,
        size: IconSizeTokens.XS,
        align: IconAlignmentTokens.left,
    },
};
export const argTypes = {
    type: {
        control: 'select',
        options: [...Object.values(TagTypeTokens)],
    },
    gradientColor: {
        control: 'select',
        options: [
            null,
            ...Object.values(GradientColorTokens),
        ],
    },
};
